var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHnlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6564",
    "data-name": "Group 6564",
    xmlns: "http://www.w3.org/2000/svg",
    width: 401.484,
    height: 108,
    viewBox: "0 0 401.484 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10108",
    "data-name": "Rectangle 10108",
    width: 401.484,
    height: 108
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6563",
    "data-name": "Group 6563",
    transform: "translate(37.691 26.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6562",
    "data-name": "Group 6562",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10109",
    "data-name": "Rectangle 10109",
    width: 1.522,
    height: 20.695,
    transform: "translate(180.133 44.474) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10110",
    "data-name": "Rectangle 10110",
    width: 1.521,
    height: 20.695,
    transform: "translate(136.741 1.08) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10111",
    "data-name": "Rectangle 10111",
    width: 20.695,
    height: 1.522,
    transform: "translate(180.147 14.631) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10112",
    "data-name": "Rectangle 10112",
    width: 20.695,
    height: 1.522,
    transform: "translate(136.753 58.025) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20865",
    "data-name": "Path 20865",
    d: "M1185.968,264.639h2.059a14.777,14.777,0,0,1-1.686,4.256l-8.577-8.577.008-.008a5.088,5.088,0,0,1-1.922-3.52,4.344,4.344,0,0,1,8.663,0h1.995v-5h-1.995v.636a6.488,6.488,0,0,0-4.331-1.634,6.177,6.177,0,0,0-6.325,6,5.628,5.628,0,0,0,1.288,3.549,8.528,8.528,0,0,0-3.131,6.2,7.962,7.962,0,0,0,8.167,7.732,8.769,8.769,0,0,0,6.315-2.412l3.02,3.02,1.41-1.41-3.136-3.135.023-.032a16.244,16.244,0,0,0,2.231-5.483l.045-.187h2.1v-1.995h-6.212Zm-5.791,7.646a5.974,5.974,0,0,1-6.177-5.737,6.518,6.518,0,0,1,2.46-4.7l8.616,8.614a6.832,6.832,0,0,1-4.9,1.827Z",
    transform: "translate(-1014.905 -235.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6560",
    "data-name": "Group 6560",
    transform: "translate(0 11.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20866",
    "data-name": "Path 20866",
    d: "M249.21,241.362H229.77v-14.59h-3V258.85h3V244.131h19.44V258.85h3V226.772h-3Z",
    transform: "translate(-226.772 -226.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20867",
    "data-name": "Path 20867",
    d: "M456.568,244.086h18v-2.774h-18V229.545h20.015v-2.774H453.57v32.078h23.241v-2.774H456.568Z",
    transform: "translate(-415.875 -226.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20868",
    "data-name": "Path 20868",
    d: "M675.4,244.443a10.3,10.3,0,0,0,3.02-1.878,8.375,8.375,0,0,0,2.01-2.78,8.882,8.882,0,0,0,.725-3.658v-.089a8.613,8.613,0,0,0-.655-3.337,8.466,8.466,0,0,0-1.822-2.732,10.433,10.433,0,0,0-3.8-2.343,15.226,15.226,0,0,0-5.276-.851H656.07v32.078h3V245.837h9.781l10.008,13.014h3.8l-10.433-13.507A14.844,14.844,0,0,0,675.4,244.443Zm-16.336-1.38V229.547h10.393a10.317,10.317,0,0,1,6.459,1.775,5.7,5.7,0,0,1,2.228,4.78v.089a6.156,6.156,0,0,1-.657,2.883,6.432,6.432,0,0,1-1.815,2.141,8.536,8.536,0,0,1-2.787,1.363,12.629,12.629,0,0,1-3.569.482H659.056Z",
    transform: "translate(-584.717 -226.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20869",
    "data-name": "Path 20869",
    d: "M875.876,244.086h17.995v-2.774H875.876V229.545h20.015v-2.774H872.878v32.078h23.23v-2.774H875.876Z",
    transform: "translate(-765.489 -226.771)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6561",
    "data-name": "Group 6561",
    transform: "translate(201.977 10.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20870",
    "data-name": "Path 20870",
    d: "M1465.852,253.48l-21.182-26.708h-2.692V258.85h2.909V231.559l21.631,27.291h2.243V226.772h-2.909Z",
    transform: "translate(-1441.978 -226.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20871",
    "data-name": "Path 20871",
    d: "M1699.621,233.752a16.21,16.21,0,0,0-3.253-5.246,15.705,15.705,0,0,0-11.687-4.975,15.972,15.972,0,0,0-6.644,1.354,15.638,15.638,0,0,0-5.089,3.646,16.738,16.738,0,0,0-3.274,5.288,17.262,17.262,0,0,0-1.167,6.291v.089a17.384,17.384,0,0,0,1.144,6.267,16.2,16.2,0,0,0,3.253,5.245,15.6,15.6,0,0,0,11.686,4.975,16.024,16.024,0,0,0,6.621-1.354,15.561,15.561,0,0,0,5.111-3.646,16.732,16.732,0,0,0,3.274-5.288,17.252,17.252,0,0,0,1.167-6.209.38.38,0,0,0,0-.253,17.382,17.382,0,0,0-1.142-6.186Zm-1.944,6.452a14.822,14.822,0,0,1-.961,5.354,13.506,13.506,0,0,1-2.694,4.359,12.839,12.839,0,0,1-18.721-.045,13.74,13.74,0,0,1-2.717-4.382,14.685,14.685,0,0,1-.987-5.376v-.089a14.809,14.809,0,0,1,.961-5.354,13.485,13.485,0,0,1,2.694-4.359,12.84,12.84,0,0,1,18.721.045,13.759,13.759,0,0,1,2.717,4.382,14.692,14.692,0,0,1,.987,5.376Z",
    transform: "translate(-1630.857 -223.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20872",
    "data-name": "Path 20872",
    d: "M1955.328,226.324l-9.626,27.259-8.97-27.349h-2.276l-8.971,27.349-9.626-27.259h-3.311l11.639,32.3h2.357l8.96-26.577,8.961,26.577h2.357l11.638-32.3Z",
    transform: "translate(-1834.334 -225.78)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHnlogo);
export default __webpack_public_path__ + "static/media/HNLOGO.b2df5f1af87342dacd67d24e52b4a2a6.svg";
export { ForwardRef as ReactComponent };